<template>
  <div class="home" id="promo">
    <PromoSection />

    <Mechanics id="mechanics" />

    <PrizesSection id="prizes" />

    <WinnersSection id="winners" />

    <FaqSection id="faq" @getThanksText="getThanksText" @getErrorText="getErrorText" />
  </div>
</template>

<script>
import Mechanics from "@/components/Mechanics.vue";
import FaqSection from "@/components/FaqSection.vue";
import PromoSection from "@/components/PromoSection.vue";
import PrizesSection from "@/components/PrizesSection.vue";
import WinnersSection from "@/components/WinnersSection.vue";

export default {
  name: "Home",
  components: {
    Mechanics,
    FaqSection,
    PromoSection,
    PrizesSection,
    WinnersSection,
  },

  data() {
    return {
      dismiss: true,
      policiesLink: "",
    };
  },

  mounted() {},

  methods: {
    getThanksText(value) {
      this.thanksText = value;
    },

    getThanksTitle(value) {
      this.thanksTitle = value;
    },

    getErrorText(value) {
      this.errorText = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.d-flex {
  justify-content: space-between;

  @media (max-width: 999px) {
    flex-direction: column !important;
  }
}

.home {
  padding-top: 41px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;

  @media (max-width: 768px) {
    padding-top: 24px;
    padding-left: 10px;
    padding-right: 10px;
  }
}

p {
  max-width: 700px;
  font-family: $regular;
  font-size: 18px;
  margin: 0;
  text-align: left;
}

.button {
  max-width: 180px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 999px) {
    margin-top: 25px;
    max-width: none;
  }
}
</style>
